import * as React from 'react'
import Toggle from '@doordash/component-toggle'
import { Inset, Text, Colors } from '@doordash/design-language'
import styled from 'styled-components'

// Default link doesnt have the corrent font
const Link = styled(Text)`
  cursor: pointer;
  font-weight: 500;
  font-family: DD-TTNorms, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol';
`
/* 
  TODO: AUSL-358 Update link handling for inline links. Currently only 
  support links at the end of the checkbox label.
*/
export const CheckboxComponent = ({ value, ...props }) => {
  const hasLink = !!props.link_text

  if (!hasLink) {
    return <Toggle isSelected={value} {...props} />
  }

  const { label, link_text, link_href, ...newProps } = props

  return (
    <Toggle isSelected={value}
      {...newProps}
      renderLabel={() => (
        <div>
          <Inset
            horizontalSize={Inset.Sizes.XSmall}
            verticalSize={Inset.Sizes.None}
          >
            <Text
              tag="span"
              display={Text.DisplayModes.Inline}
            >
              {label}
            </Text>
            &nbsp;
            <Link
              href={link_href}
              tag='a'
              display={Text.DisplayModes.Inline}
              target='_blank'
              color={Colors.SystemGrey80}
            >
              {link_text}
            </Link>
          </Inset>
        </div>
      )}
    />
  )

}
